// CSS Modules - component class name prefix: TextImageElement__

<template>
  <figure :class="[{ TextImageElement__imageRight: imageRight }, $style.container]">
    <div :class="$style.imageWrapper">
      <div
        :class="$style.image"
        :style="{backgroundImage: `url(${image})`}">
        <img :src="image" :alt="linkTitle">
      </div>
    </div>
    <figcaption>
      <slot></slot>
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: "TextImageElement",
  props: {
    imageRight: {
      type: Boolean,
      default: false
    },
    linkTitle: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    }
  }
};
</script>

<style module lang="scss">
@import "./TextImageElement.scss";
</style>
